export class SimpIn {
    constructor() {}
    commonStep = 'stepper.form.commun.SIMP.step';
    step = 'stepper.form.simp_in.step';
    step1 = 'stepper.form.simp_in.step1';
    step2 = 'stepper.form.simp_in.step2';
    step3 = 'stepper.form.simp_in.step3';
    step4 = 'stepper.form.simp_in.step4';
    step5 = 'stepper.form.simp_in.step5';
  }
